import { Component } from "react";
import { reportClientError } from "../../../utils/error-reporter";

// Si algo rompe la página del test, en vez de la pantalla en blanco se muestra cómo
// seguir. El avance ya está guardado (servidor y copia local), así que recargar
// retoma donde iba.
class TestErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    reportClientError('render_error', error, { componentStack: String(info?.componentStack || '').slice(0, 1500) });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="test-loading test-load-error">
        <h1>Algo salió mal</h1>
        <p>
          No te preocupes: tus respuestas quedaron guardadas. Recarga la página para
          continuar donde ibas.
        </p>
        <button type="button" onClick={() => window.location.reload()}>
          Recargar
        </button>
        <p>
          Si el problema continúa, contacta a la persona que te envió la prueba.
        </p>
      </div>
    );
  }
}

export default TestErrorBoundary;
